import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './componentes/Login';
import Formulario from './componentes/Formulario';
import VerMatricula from './componentes/VerMatricula';
import LoginUsuario from './componentes/LoginUsuario';
import ListadoEstudiantes from './componentes/ListadoEstudiantes';
import RedireccionInicial from './componentes/RedireccionInicial';
import DashboardAdmin from './componentes/DashboardAdmin';
import GestionUsuarios from './componentes/GestionUsuarios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App">
      <Router basename="/revision_matricula">
        <Routes>
          <Route path="/" element={<RedireccionInicial />} />
          <Route path="/login" element={<Login />} />
          <Route path="/formulario" element={<Formulario />} />
          <Route path="/verMatricula" element={<VerMatricula />} />
          <Route path="/loginUsuario" element={<LoginUsuario />} />
          <Route path="/listado-estudiantes" element={<ListadoEstudiantes />} />
          <Route path="/dashboard-admin" element={<DashboardAdmin />} />
          <Route path="/gestion-usuarios" element={<GestionUsuarios />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
